@let item = entity();
@let isEditable = editable();
@let columns = entityColumns();
@let partialEntity = isPartialEntity();
@let saving = isSaving();

<ng-container [ngTemplateOutlet]="ItemInfos" [ngTemplateOutletContext]="{item: item, isColumn: false}"></ng-container>

@if (columns.length >= 1) {
  <div class="flex flex-col">
    @for (column of columns; track column.id;) {
      <ng-container [ngTemplateOutlet]="ItemInfos" [ngTemplateOutletContext]="{item: column, isColumn: true}"></ng-container>
    }
  </div>
}

<ng-template #ItemInfos let-item="item" let-isColumn="isColumn">
  <div class="group w-full h-12 px-2
              grid grid-cols-[3rem_1fr_0rem] items-center
              [&.editable]:hover:grid-cols-[3rem_1fr_2rem]
              [&.partial]:h-12
              [&.column]:h-8
              [&.column]:pl-6
              [&.column]:grid-cols-[2rem_1fr_0rem]
              [&.partial]:hover:bg-gray-50
              hover:delay-75
              hover:bg-green-50
              hover:[&.editable]:[&.column]:grid-cols-[2rem_1fr_3.5rem]
              transition-all
              delay-750"
        [class.editable]="isEditable"
        [class.column]="isColumn"
        [class.partial]="!isColumn && partialEntity"
        mirTooltip
          [theme]="'light'"
          [placement]="'left'"
          [tooltip]="executionReferentialTooltip()">
    <img class="h-10 w-10
                group-[.column]:h-6
                group-[.column]:w-6
                group-[.column]:drop-shadow
                group-[.partial]:saturate-[25%]
                group-[.partial]:opacity-85"
        [src]="item.imageSrc">
    <div class="w-full truncate font-medium
                group-[.partial]:text-gray-600
                group-[.partial]:italic
                group-[.partial]:font-normal">
      {{getItemLabel(item)}}
    </div>
    <div class="w-full h-fit flex justify-end items-center gap-x-1 overflow-hidden pr-3">
      @if (isEditable) {
        @if (isColumn) {
          <button small cover ghost icon mirButton
              [disabled]="saving"
              [title]="columnItemCommentTooltip(item)"
              (click)="handleCommentAction($event, item)">
            @if (itemHasComment(item)) {
              <MirIcon hover="accent">edit</MirIcon>
            } @else {
              <MirIcon hover="accent">note</MirIcon>
            }
          </button>
        }
        <button small cover ghost icon mirButton
            [disabled]="saving"
            [title]="'UI.Delete' | translate"
            (click)="handleDeleteItem($event, item)">
          <MirIcon hover="warn">close</MirIcon>
        </button>
      }
    </div>
  </div>
</ng-template>
